import get from "lodash/get"

export const selectEventResourcesList = state =>
  get(state, `eventResources.data`)

export const selectEventAvailableResourcesList = state =>
  get(state, `eventResources.available.data`)

export const selectEventAvailableResourcesListTotalCount = state =>
  get(state, `eventResources.available.total`)

export const eventResourcePending = state =>
  get(state, `eventResources.status.pending`)
